import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: {
    isLogged: false,
    userDetails: {},
    userSites: {},
    currentSite: {},
    activeDashboard: null,
    business: [],
  },
  reducers: {
    setIsLogged: (state, action) => {
      state.isLogged = action.payload;
    },
    setUserDetails: (state, action) => {
      state.userDetails = action.payload;
    },
    setSiteDetails: (state, action) => {
      state.userSites = action.payload;
    },
    setCurrentSite: (state, action) => {
      state.currentSite = action.payload;
    },
    setActiveDashboard: (state, action) => {
      state.activeDashboard = action.payload;
    },
    setBusiness: (state, action) => {
      state.business = action.payload;
    },
  },
});

export const { setIsLogged, setUserDetails, setSiteDetails, setCurrentSite, setActiveDashboard, setBusiness } =
  userSlice.actions;

export default userSlice;
